import { API_BASE } from 'shared/constants/Api'

export const KIVRA_REGISTER_TENANT = `${API_BASE}/api/v2/marketplace/kivra/onboarding/tenants/`
export const KIVRA_TENANT_VALIDATE = `${API_BASE}/api/v2/marketplace/kivra/onboarding/tenants/validate/`
export const KIVRA_CLIENTS_INTEGRATE = `${API_BASE}/api/v2/marketplace/kivra/onboarding/clients/integrate/`
export const KIVRA_CLIENTS_VALIDATE = `${API_BASE}/api/v2/marketplace/kivra/onboarding/clients/validate/`
export const KIVRA_VALIDATE_INVOICE_SENDING = `${API_BASE}/api/v2/marketplace/kivra/factoring/validate_invoice_sending/`
export const KIVRA_SEND_INVOICE = `${API_BASE}/api/v2/marketplace/kivra/factoring/invoices/`
